import { useMemo } from 'react'
import { useRoutes } from 'react-router-dom'
import { useAuth } from 'modules/auth/hooks'
import {
  APP_ROUTES,
  AUTHENTICATED_ROUTES,
  NONE_AUTHENTICATED_ROUTES
} from '../../constants'

export const Routes = () => {
  const { user, isAuthComplete } = useAuth()

  const routes = useMemo(
    () => [
      ...APP_ROUTES,
      ...(isAuthComplete && user
        ? AUTHENTICATED_ROUTES
        : NONE_AUTHENTICATED_ROUTES)
    ],
    [isAuthComplete, user]
  )

  return useRoutes(routes)
}
